var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg002ControlPanel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF6C37;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M432,512c-11,0-20-9-20-20v-40c0-11,9-20,20-20s20,9,20,20v40C452,503,443,512,432,512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80,512c-11,0-20-9-20-20v-40c0-11,9-20,20-20s20,9,20,20v40C100,503,91,512,80,512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,512c-11,0-20-9-20-20V252c0-11,9-20,20-20c11,0,20,9,20,20v240C276,503,267,512,256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452,272V20c0-11-9-20-20-20s-20,9-20,20v252c-33.1,0-60,26.9-60,60s26.9,60,60,60h40c33.1,0,60-26.9,60-60 S485.1,272,452,272z M452,352h-40c-11,0-20-9-20-20s9-20,20-20h40c11,0,20,9,20,20S463,352,452,352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100,272V20c0-11-9-20-20-20S60,9,60,20v252c-33.1,0-60,26.9-60,60s26.9,60,60,60h40c33.1,0,60-26.9,60-60 S133.1,272,100,272z M100,352H60c-11,0-20-9-20-20s9-20,20-20h40c11,0,20,9,20,20S111,352,100,352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M276,72V20c0-11-9-20-20-20s-20,9-20,20v52c-33.1,0-60,26.9-60,60s26.9,60,60,60h40c33.1,0,60-26.9,60-60 S309.1,72,276,72z M276,152h-40c-11,0-20-9-20-20s9-20,20-20h40c11,0,20,9,20,20S287,152,276,152z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg002ControlPanel);
export default __webpack_public_path__ + "static/media/002-control-panel.2270bcd073d239d865b9566fcc26ae58.svg";
export { ForwardRef as ReactComponent };